/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesModule
 * Purpose		: Module for EmployeeTerritories.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { EmployeeTerritoriesService } from './EmployeeTerritories.service';
import { EmployeeTerritoriesListComponent } from './EmployeeTerritoriesList.component';
import { EmployeeTerritoriesSearchComponent } from './EmployeeTerritoriesSearch.component';
import { EmployeeTerritoriesAddComponent } from './EmployeeTerritoriesAdd.component';
import { EmployeeTerritoriesEditComponent } from './EmployeeTerritoriesEdit.component';
import { EmployeeTerritoriesDetailsComponent } from './EmployeeTerritoriesDetails.component';

import { EmployeeTerritoriesRoutingModule } from './EmployeeTerritories-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    EmployeeTerritoriesRoutingModule
  ],
  declarations: [
    EmployeeTerritoriesListComponent,
	EmployeeTerritoriesSearchComponent,
    EmployeeTerritoriesEditComponent,
    EmployeeTerritoriesAddComponent,
	EmployeeTerritoriesDetailsComponent
  ],
  providers: [
    EmployeeTerritoriesService
  ]
})

export class EmployeeTerritoriesModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/EmployeeTerritories/EmployeeTerritories.module.ts